import { ajax } from 'rxjs/ajax';
import { switchMap } from 'rxjs/operators';
import { jsonHeaders$ } from './headers';
import { combineLatest } from 'rxjs';
import { memberId$ } from './subjects';
import { HedisPopUpConfig } from 'interfaces/MemberPortalConfig';

const hedisPopUpService = {
    get$: () => combineLatest(jsonHeaders$).pipe(
        switchMap(([headers]) =>
            ajax<HedisPopUpConfig[]>({
                method: 'GET',
                url: 'api/hedispopups',
                headers,
            })
        )
    ),
};

export default hedisPopUpService;
